//How to use
// loadJS('file.js', function () {
//   alert(1);
// });

function loadJS(url, callback) {
  var script = document.createElement('script'),
    fn = callback || function () { };
  script.type = 'text/javascript';
  //IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == 'loaded' || script.readyState == 'complete') {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    //Other browsers
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}